jQuery(document).ready(function($) {

    // Update file input to accept multiple files
    $('#evidenceFile').attr('multiple', 'multiple');

    // Add drag and drop functionality for NEW EVIDENCE modal only
    // Note: Add Files modal has its own handler below - don't use generic '.drop-zone' selector
    var $dropZone = $('#newEvidenceDropZone');
    var $fileInput = $('#evidenceFile');
    var $fileList = $('#newEvidenceFileList');

    // Persist selected files for New Evidence modal so multiple picks (e.g. different folders) accumulate.
    // We do NOT write to the file input (avoids programmatic change events and double-upload of first batch).
    // add-evidence.js reads from getNewEvidenceSelectedFiles() at submit time.
    var newEvidenceSelectedFiles = [];
    window.getNewEvidenceSelectedFiles = function() {
        return newEvidenceSelectedFiles.slice();
    };

    var isNewEvidencePage = $('#newEvidenceModal').length > 0;

    // Handle drag and drop events for NEW EVIDENCE modal only
    $dropZone.on('dragover', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).addClass('dragover');
    }).on('dragleave', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).removeClass('dragover');
    }).on('drop', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).removeClass('dragover');
        
        var files = e.originalEvent.dataTransfer.files;
        console.log('=== NEW EVIDENCE: Drag and drop event ===');
        console.log('Files dropped:', files.length);
        handleFiles(files);
    });

    // Handle file input change (user picked files; input has only the latest selection, we merge with newEvidenceSelectedFiles)
    $fileInput.on('change', function() {
        console.log('=== DEBUG: File input change event ===');
        console.log('Files in input:', this.files.length);
        console.log('File names:', Array.from(this.files).map(f => f.name));
        handleFiles(this.files);
    });

    // Function to handle files (used for New Evidence modal: drag-drop and file picker)
    // Always updates both the file input and the UI so submission and multi-folder selection work.
    function handleFiles(files) {
        // Don't empty the file list - we want to append new files to existing ones

        // Define file size limit (10MB)
        const maxFileSize = 10 * 1024 * 1024; // 10MB in bytes
        
        // Define allowed file types
        const allowedTypes = [
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'image/jpeg',
            'image/png',
            'image/webp',
            'image/gif',
            'video/mp4',
            'text/plain'
        ];
        
        // Define allowed file extensions
        const allowedExtensions = [
            '.pdf', '.docx', '.xlsx', '.pptx',
            '.jpg', '.jpeg', '.png', '.webp', '.gif', '.mp4', '.txt'
        ];

        // Get existing files from the file list display (case-insensitive for duplicate check)
        const existingFileNamesLower = [];
        $fileList.find('.file-name').each(function() {
            existingFileNamesLower.push($(this).text().toLowerCase());
        });
        
        console.log('=== DEBUG: handleFiles called ===');
        console.log('New files being processed:', files.length);
        console.log('Existing files in list:', existingFileNamesLower.length);
        console.log('Existing file names in list:', existingFileNamesLower);
        
        // Create a DataTransfer object to handle the files
        const dataTransfer = new DataTransfer();
        
        // Use persisted array so multiple picks (e.g. different folders) accumulate; native input is replaced on each pick
        // Deduplicate existing by name (first wins) so we never process the same file twice
        var existingFiles = newEvidenceSelectedFiles.length > 0 ? newEvidenceSelectedFiles : ($fileInput[0] ? Array.from($fileInput[0].files) : []);
        var seenNames = {};
        existingFiles = existingFiles.filter(function(f) {
            var k = f.name.toLowerCase();
            if (seenNames[k]) return false;
            seenNames[k] = true;
            return true;
        });
        existingFiles.forEach(file => dataTransfer.items.add(file));
        
        // Track files being added in this batch to avoid false duplicates
        const filesBeingAdded = [];
        
        for (var i = 0; i < files.length; i++) {
            var file = files[i];
            
            console.log(`Processing file ${i + 1}/${files.length}: "${file.name}"`);
            
            // Check if file already exists in the file list display (case-insensitive)
            const fileExistsInList = existingFileNamesLower.indexOf(file.name.toLowerCase()) !== -1;
            // Check if file already exists in current batch (case-insensitive)
            const fileExistsInBatch = filesBeingAdded.some(addedFile => addedFile.name.toLowerCase() === file.name.toLowerCase());
            
            console.log(`  - Exists in list: ${fileExistsInList}`);
            console.log(`  - Exists in batch: ${fileExistsInBatch}`);
            
            if (fileExistsInList || fileExistsInBatch) {
                console.log(`  - DUPLICATE DETECTED: "${file.name}"`);
                alert(`File "${file.name}" is already selected.`);
                continue;
            }
            
            console.log(`  - Adding file: "${file.name}"`);
            // Add to batch tracking
            filesBeingAdded.push(file);
            
            // Check file size
            if (file.size > maxFileSize) {
                alert(`File "${file.name}" is too large. Maximum file size is 10MB. Current size: ${formatFileSize(file.size)}`);
                continue;
            }
            
            // Check file type and extension
            const fileExtension = '.' + file.name.split('.').pop().toLowerCase();

            // If MIME type is empty or application/octet-stream, check extension
            let isValidType = false;
            if (file.type && file.type !== 'application/octet-stream') {
                isValidType = allowedTypes.includes(file.type);
            }

            // Also check extension as fallback
            const isValidExtension = allowedExtensions.includes(fileExtension);

            if (!isValidType && !isValidExtension) {
                alert(`File "${file.name}" is not a supported format. Please upload only PDF, DOCX, XLSX, PPTX, JPG, JPEG, PNG, WEBP, GIF, MP4, or TXT files.`);
                continue;
            }
            
            // Add valid file to DataTransfer object
            dataTransfer.items.add(file);
            
            var fileSize = formatFileSize(file.size);
            
            var $fileItem = $('<div class="file-item d-flex align-items-center mb-2"></div>');
            $fileItem.append(`
                <i class="fas fa-file me-2"></i>
                <span class="file-name">${file.name}</span>
                <span class="file-size ms-2 text-muted">(${fileSize})</span>
                <button type="button" class="btn btn-sm btn-danger ms-auto remove-file">
                    <img src="${evidenceData.theme_url}/icons/close.svg" alt="Remove" class="icon-sm" height="7" width="7">
                </button>
            `);
            
            $fileList.append($fileItem);
        }

        // Persist for next drop/change; deduplicate by name so we never have the same file twice
        var filesArray = Array.from(dataTransfer.files);
        var seen = {};
        newEvidenceSelectedFiles = filesArray.filter(function(f) {
            var k = f.name.toLowerCase();
            if (seen[k]) return false;
            seen[k] = true;
            return true;
        });

        // Update select2 dropdown positions after file list changes (only if not on new evidence page)
        if (!isNewEvidencePage) {
            setTimeout(function() {
                // Use a more gentle approach - just trigger position update
                $('#newEvidenceModal .select2-container').each(function() {
                    var $select = $(this).prev('select');
                    if ($select.length && $select.hasClass('select2-hidden-accessible')) {
                        // Trigger select2 to update its position without destroying
                        $select.trigger('select2:open').trigger('select2:close');
                    }
                });
            }, 100);
        }
    }

    // Function to handle files for new evidence page (preview only)
    function handleFilesPreviewOnly(files) {
        // Define file size limit (10MB)
        const maxFileSize = 10 * 1024 * 1024; // 10MB in bytes

        // Define allowed file types
        const allowedTypes = [
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'image/jpeg',
            'image/png',
            'image/webp',
            'image/gif',
            'video/mp4',
            'text/plain'
        ];

        // Define allowed file extensions
        const allowedExtensions = [
            '.pdf', '.docx', '.xlsx', '.pptx',
            '.jpg', '.jpeg', '.png', '.webp', '.gif', '.mp4', '.txt'
        ];

        for (var i = 0; i < files.length; i++) {
            var file = files[i];

            console.log(`Preview processing file ${i + 1}/${files.length}: "${file.name}"`);

            // Check file size
            if (file.size > maxFileSize) {
                alert(`File "${file.name}" is too large. Maximum file size is 10MB. Current size: ${formatFileSize(file.size)}`);
                continue;
            }

            // Check file type and extension
            const fileExtension = '.' + file.name.split('.').pop().toLowerCase();

            // If MIME type is empty or application/octet-stream, check extension
            let isValidType = false;
            if (file.type && file.type !== 'application/octet-stream') {
                isValidType = allowedTypes.includes(file.type);
            }

            // Also check extension as fallback
            const isValidExtension = allowedExtensions.includes(fileExtension);

            if (!isValidType && !isValidExtension) {
                alert(`File "${file.name}" is not a supported format. Please upload only PDF, DOCX, XLSX, PPTX, JPG, JPEG, PNG, WEBP, GIF, MP4, or TXT files.`);
                continue;
            }

            var fileSize = formatFileSize(file.size);

            var $fileItem = $('<div class="file-item d-flex align-items-center mb-2"></div>');
            $fileItem.append(`
                <i class="fas fa-file me-2"></i>
                <span class="file-name">${file.name}</span>
                <span class="file-size ms-2 text-muted">(${fileSize})</span>
                <button type="button" class="btn btn-sm btn-danger ms-auto remove-file">
                    <img src="${evidenceData.theme_url}/icons/close.svg" alt="Remove" class="icon-sm" height="7" width="7">
                </button>
            `);

            $fileList.append($fileItem);
        }
    }

    // Function to format file size
    function formatFileSize(bytes) {
        if (bytes === 0) return '0 Bytes';
        var k = 1024;
        var sizes = ['Bytes', 'KB', 'MB', 'GB'];
        var i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    }

    // Handle file removal
    $fileList.on('click', '.remove-file', function() {
        var $fileItem = $(this).closest('.file-item');
        var fileName = $fileItem.find('.file-name').text();

        // If we're on the new evidence page, remove the file from the persisted list only (no input update)
        if (isNewEvidencePage) {
            var remainingFiles = [];
            $fileList.find('.file-item').not($fileItem).each(function() {
                var itemFileName = $(this).find('.file-name').text();
                for (var i = 0; i < newEvidenceSelectedFiles.length; i++) {
                    if (newEvidenceSelectedFiles[i].name === itemFileName) {
                        remainingFiles.push(newEvidenceSelectedFiles[i]);
                        break;
                    }
                }
            });
            newEvidenceSelectedFiles = remainingFiles;
        }

        $fileItem.remove();

        // Update select2 dropdown positions after file list changes (only if not on new evidence page)
        if (!isNewEvidencePage) {
            setTimeout(function() {
                // Use a more gentle approach - just trigger position update
                $('#newEvidenceModal .select2-container').each(function() {
                    var $select = $(this).prev('select');
                    if ($select.length && $select.hasClass('select2-hidden-accessible')) {
                        // Trigger select2 to update its position without destroying
                        $select.trigger('select2:open').trigger('select2:close');
                    }
                });
            }, 100);
        }
    });

    // Clear New Evidence file state when modal is closed so next open starts fresh
    $('#newEvidenceModal').on('hidden.bs.modal', function() {
        newEvidenceSelectedFiles = [];
        $fileList.empty();
        if ($fileInput.length && $fileInput[0]) {
            $fileInput[0].value = '';
        }
    });

    // Function to view evidence file
    window.viewEvidence = function(evidenceId, fileId) {
        // Make AJAX request to get presigned URL
        jQuery.ajax({
            url: evidenceData.ajax_url,
            type: 'POST',
            data: {
                action: 'get_evidence_url',
                evidence_id: evidenceId,
                file_id: fileId,
                nonce: evidenceData.nonce
            },
            success: function(response) {
                console.log('Server response:', response);
                if (response.success) {
                    const data = response.data;
                    console.log('File data:', data); // Debug log
                    
                    // Create modal content based on file type
                    let modalContent = '';
                    let modalSize = 'modal-lg';

                    switch (data.file_type) {
                        case 'image':
                            modalContent = `
                                <div class="evidence-preview">
                                    <img src="${data.url}" alt="Evidence Preview" class="img-fluid">
                                    <div class="mt-3 text-center">
                                        <a href="${data.url}" target="_blank" class="btn btn-primary">
                                            <i class="fas fa-external-link-alt"></i> Open in New Tab
                                        </a>
                                    </div>
                                </div>
                            `;
                            break;

                        case 'pdf':
                            modalSize = 'modal-xl';
                            modalContent = `
                                <div class="evidence-preview">
                                    <div class="pdf-preview">
                                        <iframe src="${data.url}" type="application/pdf" class="pdf-viewer"></iframe>
                                    </div>
                                    <div class="mt-3 text-center">
                                        <a href="${data.url}" target="_blank" class="btn btn-primary">
                                            <i class="fas fa-external-link-alt"></i> Open in New Tab
                                        </a>
                                    </div>
                                </div>
                            `;
                            break;

                        case 'text':
                            modalContent = `
                                <div class="evidence-preview">
                                    <div class="text-content p-3 border rounded" style="max-height: 500px; overflow-y: auto;">
                                        <pre class="text-content-inner"></pre>
                                    </div>
                                    <div class="mt-3 text-center">
                                        <a href="${data.url}" target="_blank" class="btn btn-primary">
                                            <i class="fas fa-download"></i> Download File
                                        </a>
                                    </div>
                                </div>
                            `;
                            break;

                        case 'office':
                            modalSize = 'modal-xl';
                            const officeViewerUrl = `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(data.url)}`;
                            modalContent = `
                                <div class="evidence-preview">
                                    <div class="ratio ratio-16x9">
                                        <iframe src="${officeViewerUrl}" type="application/pdf" class="pdf-viewer"></iframe>
                                    </div>
                                    <div class="mt-3 text-center">
                                        <a href="${data.url}" target="_blank" class="btn btn-primary">
                                            <i class="fas fa-external-link-alt"></i> Open in New Tab
                                        </a>
                                    </div>
                                </div>
                            `;
                            break;
                    }

                    // Create modal
                    const modal = $('#viewEvidenceModal');
                    modal.find('.modal-body').html(modalContent);
                    modal.find('.modal-title').text(data.file_name);
                    modal.find('.modal-footer').hide();
                    
                    // Update modal size class
                    modal.find('.modal-dialog').removeClass('modal-lg modal-xl').addClass(modalSize);
                    
                    modal.modal('show');
                } else {
                    console.error('Error loading evidence file:', response.data);
                    alert('Error: ' + (response.data.message || 'Unknown error occurred'));
                }
            },
            error: function(xhr, status, error) {
                console.error('AJAX error:', {
                    status: status,
                    error: error,
                    response: xhr.responseText
                });
                alert('An error occurred while loading the evidence file. Please check the console for details.');
            }
        });
    };

    // Function to download evidence file
    window.downloadEvidence = function(evidenceId, fileId, fileName) {
        // Make AJAX request to get presigned URL
        jQuery.ajax({
            url: evidenceData.ajax_url,
            type: 'POST',
            data: {
                action: 'get_evidence_url',
                evidence_id: evidenceId,
                file_id: fileId,
                nonce: evidenceData.nonce
            },
            success: function(response) {
                console.log('Download response:', response);
                if (response.success) {
                    const data = response.data;
                    console.log('File data for download:', data);
                    
                    // Force download by fetching the file as a blob
                    fetch(data.url)
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }
                            return response.blob();
                        })
                        .then(blob => {
                            // Create a blob URL
                            const blobUrl = window.URL.createObjectURL(blob);
                            
                            // Create a temporary anchor element to trigger download
                            const link = document.createElement('a');
                            link.href = blobUrl;
                            link.download = fileName || data.file_name || 'download';
                            
                            // Append to body, click, and remove
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            
                            // Clean up the blob URL
                            window.URL.revokeObjectURL(blobUrl);
                            
                            console.log('Download initiated for:', fileName);
                        })
                        .catch(error => {
                            console.error('Error downloading file:', error);
                            alert('Error downloading the file. Please try again.');
                        });
                } else {
                    console.error('Error downloading evidence file:', response.data);
                    alert('Error: ' + (response.data.message || 'Unknown error occurred'));
                }
            },
            error: function(xhr, status, error) {
                console.error('AJAX error during download:', {
                    status: status,
                    error: error,
                    response: xhr.responseText
                });
                alert('An error occurred while downloading the evidence file. Please check the console for details.');
            }
        });
    };

    // Function to delete a specific evidence file
    window.deleteEvidenceFile = function(evidenceId, fileId, fileName) {
        // Show confirmation dialog
        if (!confirm(`Are you sure you want to delete "${fileName}"? This action cannot be undone.`)) {
            return;
        }

        // Make AJAX request to delete the file
        jQuery.ajax({
            url: evidenceData.ajax_url,
            type: 'POST',
            data: {
                action: 'delete_evidence_file',
                evidence_id: evidenceId,
                file_id: fileId,
                nonce: evidenceData.nonce
            },
            success: function(response) {
                console.log('Delete file response:', response);
                if (response.success) {
                    // Reload the page to refresh the file list
                    location.reload();
                } else {
                    console.error('Error deleting evidence file:', response.data);
                    alert('Error: ' + (response.data.message || 'Unknown error occurred'));
                }
            },
            error: function(xhr, status, error) {
                console.error('AJAX error during file deletion:', {
                    status: status,
                    error: error,
                    response: xhr.responseText
                });
            }
        });
    };

    // Add Files functionality for existing evidence
    // Handle Add Files button click
    $('#addEvidenceFiles').on('click', function() {
        // Show the modal
        $('#addFilesModal').modal('show');
    });

    // Add drag and drop functionality for Add Files modal
    var $addFilesDropZone = $('#addFilesModal .drop-zone');
    var $addFilesInput = $('#evidenceFiles');
    var $addFilesFileList = $('#fileList');
    var selectedFiles = []; // Store selected files for upload
    var isProcessingFiles = false; // Flag to prevent duplicate processing

    // Handle drag and drop events for Add Files modal
    $addFilesDropZone.on('dragover', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).addClass('dragover');
    }).on('dragleave', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).removeClass('dragover');
    }).on('drop', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $(this).removeClass('dragover');
        
        console.log('=== DROP EVENT ===');
        console.log('isProcessingFiles:', isProcessingFiles);
        console.log('selectedFiles before:', selectedFiles.length, selectedFiles.map(f => f.name));
        
        if (isProcessingFiles) {
            console.log('Skipping drop - already processing');
            return;
        }
        
        var files = e.originalEvent.dataTransfer.files;
        console.log('Files dropped:', files.length, Array.from(files).map(f => f.name));
        
        // Append new dropped files to existing selection
        handleAddFiles(files, true);
    });

    // Handle file input change for Add Files modal
    $addFilesInput.on('change', function() {
        console.log('=== FILE INPUT CHANGE EVENT ===');
        console.log('isProcessingFiles:', isProcessingFiles);
        console.log('selectedFiles before:', selectedFiles.length);
        
        // Skip if we're already processing files (prevents double-processing from programmatic updates)
        if (isProcessingFiles) {
            console.log('Skipping change event - already processing');
            return;
        }
        console.log('Files from input:', this.files.length, Array.from(this.files).map(f => f.name));
        // Append new files to existing selection
        handleAddFiles(this.files, true);
    });

    // Function to handle files for Add Files modal
    // Set appendMode to true to add to existing files, false to replace
    function handleAddFiles(files, appendMode = true) {
        console.log('=== handleAddFiles START ===');
        console.log('New files count:', files.length);
        console.log('Append mode:', appendMode);
        console.log('Existing selectedFiles:', selectedFiles.length, selectedFiles.map(f => f.name));
        console.log('Existing UI items:', $addFilesFileList.find('.file-item').length);
        
        if (files.length === 0 && !appendMode) {
            $addFilesFileList.empty();
            selectedFiles = [];
            $('#uploadFilesBtn').prop('disabled', true);
            return;
        }
        
        // Define file size limit (10MB)
        const maxFileSize = 10 * 1024 * 1024; // 10MB in bytes
        
        // Define allowed file types
        const allowedTypes = [
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'image/jpeg',
            'image/png',
            'image/webp',
            'image/gif',
            'video/mp4',
            'text/plain'
        ];
        
        // Define allowed file extensions
        const allowedExtensions = [
            '.pdf', '.docx', '.xlsx', '.pptx',
            '.jpg', '.jpeg', '.png', '.webp', '.gif', '.mp4', '.txt'
        ];
        
        // Get existing file names to check for duplicates
        const existingFileNames = selectedFiles.map(f => f.name);
        console.log('Existing file names for dupe check:', existingFileNames);
        
        // Create a DataTransfer object to handle the files
        const dataTransfer = new DataTransfer();
        
        // Add existing files first if in append mode
        if (appendMode && selectedFiles.length > 0) {
            console.log('Adding existing files to DataTransfer:', selectedFiles.length);
            selectedFiles.forEach(file => dataTransfer.items.add(file));
        }
        
        console.log('DataTransfer after adding existing:', dataTransfer.files.length);
        
        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            
            // Check for duplicates
            if (existingFileNames.includes(file.name)) {
                console.log(`File "${file.name}" is already in the list, skipping.`);
                continue;
            }
            
            // Check file size
            if (file.size > maxFileSize) {
                alert(`File "${file.name}" is too large. Maximum file size is 10MB. Current size: ${formatFileSize(file.size)}`);
                continue;
            }
            
            // Check file type and extension
            const fileExtension = '.' + file.name.split('.').pop().toLowerCase();

            // If MIME type is empty or application/octet-stream, check extension
            let isValidType = false;
            if (file.type && file.type !== 'application/octet-stream') {
                isValidType = allowedTypes.includes(file.type);
            }

            // Also check extension as fallback
            const isValidExtension = allowedExtensions.includes(fileExtension);

            if (!isValidType && !isValidExtension) {
                alert(`File "${file.name}" is not a supported format. Please upload only PDF, DOCX, XLSX, PPTX, JPG, JPEG, PNG, WEBP, GIF, MP4, or TXT files.`);
                continue;
            }
            
            const fileSize = formatFileSize(file.size);
            
            // Add file to DataTransfer object
            console.log('>> Adding NEW file:', file.name);
            dataTransfer.items.add(file);
            
            const $fileItem = $('<div class="file-item d-flex align-items-center mb-2"></div>');
            $fileItem.append(`
                <i class="fas fa-file me-2"></i>
                <span class="file-name">${file.name}</span>
                <span class="file-size ms-2 text-muted">(${fileSize})</span>
                <button type="button" class="btn btn-sm btn-danger ms-auto remove-file">
                    <img src="${evidenceData.theme_url}/icons/close.svg" alt="Remove" class="icon-sm" height="7" width="7">
                </button>
            `);
            
            console.log('>> Adding UI element for:', file.name);
            $addFilesFileList.append($fileItem);
        }
        
        // Store files for upload
        selectedFiles = Array.from(dataTransfer.files);
        
        // Update the file input with the selected files
        // Set flag to prevent change event from re-triggering handleAddFiles
        isProcessingFiles = true;
        $addFilesInput[0].files = dataTransfer.files;
        isProcessingFiles = false;
        
        // Debug: Log the file input state
        console.log('=== handleAddFiles END ===');
        console.log('Final selectedFiles:', selectedFiles.length, selectedFiles.map(f => f.name));
        console.log('Final UI items:', $addFilesFileList.find('.file-item').length);
        console.log('File input files:', $addFilesInput[0].files.length);
        
        // Enable upload button only if there are valid files
        if (dataTransfer.files.length > 0) {
            $('#uploadFilesBtn').prop('disabled', false);
        } else {
            $('#uploadFilesBtn').prop('disabled', true);
        }
    }

    // Handle file removal in Add Files modal
    $addFilesFileList.on('click', '.remove-file', function() {
        const fileName = $(this).closest('.file-item').find('.file-name').text();
        $(this).closest('.file-item').remove();
        
        // Remove file from selectedFiles array
        selectedFiles = selectedFiles.filter(file => file.name !== fileName);
        
        // Create a new DataTransfer object with remaining files
        const dataTransfer = new DataTransfer();
        selectedFiles.forEach(file => dataTransfer.items.add(file));
        
        // Update the file input with remaining files (with flag to prevent change event)
        isProcessingFiles = true;
        $addFilesInput[0].files = dataTransfer.files;
        isProcessingFiles = false;
        
        // If no files left, disable upload button
        if (selectedFiles.length === 0) {
            $('#uploadFilesBtn').prop('disabled', true);
        }
    });

    // Handle upload button click - uses DirectS3Uploader for direct browser-to-S3 uploads
    $('#uploadFilesBtn').on('click', function() {
        const files = selectedFiles.length > 0 ? selectedFiles : $('#evidenceFiles')[0].files;
        console.log('Upload button clicked - files in input:', $('#evidenceFiles')[0].files.length);
        console.log('Selected files:', selectedFiles.length);
        console.log('Using files:', files.length);
        
        if (files.length === 0) {
            alert('Please select files to upload');
            return;
        }
        
        // Get evidence ID from the page
        const evidenceId = window.location.pathname.split('/').pop();
        
        // Show loading state and disable button
        const $button = $('#uploadFilesBtn');
        const $cancelBtn = $('#cancelUploadBtn');
        const originalText = $button.html();
        $button.html('<i class="fas fa-spinner fa-spin me-1"></i> Uploading...').prop('disabled', true);
        
        // Show cancel button if it exists
        if ($cancelBtn.length) {
            $cancelBtn.show();
        }
        
        // Check if DirectS3Uploader is available
        if (typeof window.DirectS3Uploader === 'undefined') {
            console.warn('DirectS3Uploader not available, falling back to traditional upload');
            performTraditionalUpload(files, evidenceId, $button, originalText);
            return;
        }
        
        // Create uploader instance
        const uploader = new window.DirectS3Uploader({
            ajaxUrl: evidenceData.ajax_url,
            nonce: evidenceData.nonce,
            concurrency: 5,
            maxRetries: 3,
            
            onFileProgress: function(index, fileData) {
                updateFileProgressUI(index, fileData);
            },
            
            onFileComplete: function(index, fileData) {
                updateFileProgressUI(index, fileData);
            },
            
            onFileError: function(index, fileData) {
                updateFileProgressUI(index, fileData);
            },
            
            onOverallProgress: function(progress) {
                const percent = progress.percentComplete;
                $button.html(`<i class="fas fa-spinner fa-spin me-1"></i> Uploading ${progress.completed}/${progress.total} (${percent}%)`);
            },
            
            onAllComplete: function(results) {
                console.log('Upload complete:', results);
                
                if (results.completed > 0) {
                    // Show success message
                    $button.html('<i class="fas fa-check me-1"></i> Upload Complete!');
                    
                    // Reload after a short delay
                    setTimeout(function() {
                        location.reload();
                    }, 1500);
                } else if (results.failed > 0) {
                    $button.html(originalText).prop('disabled', false);
                    alert(`Upload failed. ${results.failed} file(s) could not be uploaded.`);
                } else {
                    $button.html(originalText).prop('disabled', false);
                }
                
                if ($cancelBtn.length) {
                    $cancelBtn.hide();
                }
            }
        });
        
        // Store uploader reference for cancel functionality
        window.currentUploader = uploader;
        
        // Initialize progress UI for each file
        initializeProgressUI(files);
        
        // Start the upload
        uploader.uploadFiles(files, evidenceId);
    });
    
    // Cancel upload button handler
    $(document).on('click', '#cancelUploadBtn', function() {
        if (window.currentUploader) {
            window.currentUploader.cancelAll();
            window.currentUploader = null;
        }
        
        $('#uploadFilesBtn').html('Upload Files').prop('disabled', false);
        $(this).hide();
        
        // Reset progress UI
        $('.file-item .upload-progress').remove();
        $('.file-item .upload-status').remove();
    });
    
    // Initialize progress UI for files
    function initializeProgressUI(files) {
        $('#fileList .file-item').each(function(index) {
            const $item = $(this);
            
            // Remove existing progress elements
            $item.find('.upload-progress-wrapper, .retry-upload').remove();
            
            // Hide the remove button during upload
            $item.find('.remove-file').hide();
            
            // Convert to card-style layout with progress bar at bottom
            $item.css({
                'flex-wrap': 'wrap',
                'padding-bottom': '0'
            });
            
            // Add full-width progress bar at the bottom
            $item.append(`
                <div class="upload-progress-wrapper w-100 mt-2">
                    <div class="progress" style="height: 6px; border-radius: 0 0 4px 4px;">
                        <div class="progress-bar" role="progressbar" style="width: 0%"></div>
                    </div>
                </div>
            `);
        });
    }
    
    // Update file progress UI
    function updateFileProgressUI(index, fileData) {
        const $item = $('#fileList .file-item').eq(index);
        if (!$item.length) return;
        
        const $progressBar = $item.find('.progress-bar');
        
        // Update progress bar width
        $progressBar.css('width', fileData.progress + '%');
        
        const StatusMap = window.FileUploadStatus || {
            PENDING: 'pending',
            GETTING_URL: 'getting_url',
            UPLOADING: 'uploading',
            COMPLETE: 'complete',
            ERROR: 'error',
            CANCELLED: 'cancelled'
        };
        
        switch (fileData.status) {
            case StatusMap.PENDING:
            case 'pending':
                $progressBar.removeClass().addClass('progress-bar bg-secondary');
                break;
            case StatusMap.GETTING_URL:
            case 'getting_url':
                $progressBar.removeClass().addClass('progress-bar bg-info progress-bar-striped progress-bar-animated');
                break;
            case StatusMap.UPLOADING:
            case 'uploading':
                $progressBar.removeClass().addClass('progress-bar bg-primary');
                break;
            case StatusMap.COMPLETE:
            case 'complete':
                $progressBar.removeClass().addClass('progress-bar bg-success').css('width', '100%');
                // Keep remove button hidden - page will refresh after all uploads complete
                break;
            case StatusMap.ERROR:
            case 'error':
                $progressBar.removeClass().addClass('progress-bar bg-danger');
                // Add retry button if not exists
                if (!$item.find('.retry-upload').length) {
                    $item.find('.file-size').after(`<button type="button" class="btn btn-sm btn-outline-warning ms-2 retry-upload" data-index="${index}" style="padding: 2px 8px; font-size: 12px;">Retry</button>`);
                }
                break;
            case StatusMap.CANCELLED:
            case 'cancelled':
                $progressBar.removeClass().addClass('progress-bar bg-warning');
                break;
        }
    }
    
    // Retry upload handler
    $(document).on('click', '.retry-upload', function() {
        const index = $(this).data('index');
        if (window.currentUploader) {
            $(this).remove();
            window.currentUploader.retryFile(index);
        }
    });
    
    // Fallback traditional upload (for when DirectS3Uploader is not loaded)
    function performTraditionalUpload(files, evidenceId, $button, originalText) {
        const formData = new FormData();
        formData.append('action', 'add_evidence_files');
        formData.append('nonce', evidenceData.nonce);
        formData.append('evidence_id', evidenceId);
        
        for (let i = 0; i < files.length; i++) {
            formData.append('evidenceFiles[]', files[i]);
        }
        
        $.ajax({
            url: evidenceData.ajax_url,
            type: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            success: function(response) {
                if (response.success) {
                    setTimeout(function() {
                        location.reload();
                    }, 1500);
                } else {
                    alert(response.data.message || 'Error adding files');
                }
            },
            error: function(xhr, status, error) {
                console.error('Error adding files:', error);
                alert('Error adding files. Please try again.');
            },
            complete: function() {
                $button.html(originalText).prop('disabled', true);
            }
        });
    }

    // Reset modal when closed
    $('#addFilesModal').on('hidden.bs.modal', function() {
        $('#evidenceFiles').val('');
        $('#fileList').empty();
        $('#uploadFilesBtn').prop('disabled', true);
        selectedFiles = []; // Clear selected files
        isProcessingFiles = false; // Reset flag
        // Remove dragover class if it's still there
        $('#addFilesModal .drop-zone').removeClass('dragover');
    });

    // Handle file input for edit form
    $('#editEvidenceFile').on('change', function() {
        handleEditFiles(this.files);
    });

    // Function to handle files for edit form
    function handleEditFiles(files) {
        const $fileList = $('#editEvidenceModal .file-list');
        $fileList.empty();
        
        // Define file size limit (10MB)
        const maxFileSize = 10 * 1024 * 1024; // 10MB in bytes
        
        // Define allowed file types
        const allowedTypes = [
            'application/pdf',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'image/jpeg',
            'image/png',
            'image/webp',
            'image/gif',
            'video/mp4',
            'text/plain'
        ];
        
        // Define allowed file extensions
        const allowedExtensions = [
            '.pdf', '.docx', '.xlsx', '.pptx',
            '.jpg', '.jpeg', '.png', '.webp', '.gif', '.mp4', '.txt'
        ];

        // Create a DataTransfer object to handle the files
        const dataTransfer = new DataTransfer();
        
        for (var i = 0; i < files.length; i++) {
            var file = files[i];
            
            // Check file size
            if (file.size > maxFileSize) {
                alert(`File "${file.name}" is too large. Maximum file size is 10MB. Current size: ${formatFileSize(file.size)}`);
                continue;
            }
            
            // Check file type and extension
            const fileExtension = '.' + file.name.split('.').pop().toLowerCase();

            // If MIME type is empty or application/octet-stream, check extension
            let isValidType = false;
            if (file.type && file.type !== 'application/octet-stream') {
                isValidType = allowedTypes.includes(file.type);
            }

            // Also check extension as fallback
            const isValidExtension = allowedExtensions.includes(fileExtension);

            if (!isValidType && !isValidExtension) {
                alert(`File "${file.name}" is not a supported format. Please upload only PDF, DOCX, XLSX, PPTX, JPG, JPEG, PNG, WEBP, GIF, MP4, or TXT files.`);
                continue;
            }
            
            // Add valid file to DataTransfer object
            dataTransfer.items.add(file);
            
            var fileSize = formatFileSize(file.size);
            
            var $fileItem = $('<div class="file-item d-flex align-items-center mb-2"></div>');
            $fileItem.append(`
                <i class="fas fa-file me-2"></i>
                <span class="file-name">${file.name}</span>
                <span class="file-size ms-2 text-muted">(${fileSize})</span>
                <button type="button" class="btn btn-sm btn-danger ms-auto remove-file">
                    <img src="${evidenceData.theme_url}/icons/close.svg" alt="Remove" class="icon-sm" height="7" width="7">
                </button>
            `);
            
            $fileList.append($fileItem);
        }

        // Update the file input with the selected files
        const editFileInput = $('#editEvidenceFile')[0];
        if (editFileInput) {
            editFileInput.files = dataTransfer.files;
        }
    }

    // Handle file removal in edit form
    $('#editEvidenceModal').on('click', '.remove-file', function() {
        $(this).closest('.file-item').remove();
        
        // Create a new DataTransfer object with remaining files
        const dataTransfer = new DataTransfer();
        const remainingFiles = [];
        
        // Get all remaining file items
        $('#editEvidenceModal .file-item').each(function() {
            const fileName = $(this).find('.file-name').text();
            // Find the original file from the input's files
            for (let i = 0; i < $('#editEvidenceFile')[0].files.length; i++) {
                if ($('#editEvidenceFile')[0].files[i].name === fileName) {
                    remainingFiles.push($('#editEvidenceFile')[0].files[i]);
                    break;
                }
            }
        });
        
        // Add remaining files to DataTransfer
        remainingFiles.forEach(file => dataTransfer.items.add(file));
        
        // Update the file input with remaining files
        const editFileInput = $('#editEvidenceFile')[0];
        if (editFileInput) {
            editFileInput.files = dataTransfer.files;
        }
    });

});
